import { SearchOffers } from '@lambda/commons/apis/elasticsearch/types';
import useSWR from 'swr';

export function useYouMayAlsoLike(pskus: string[]) {
  const { data } = useSWR<SearchOffers[]>(
    `/api/collections/offers?pskus=${pskus.join('|')}`,
  );

  return data;
}
